import React, { useEffect, useState } from "react";
import { Card, Button, Col, Form } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import ChartComponent from "../Highcharts/ChartComponent";
import {
  commoditiesBarConfig,
  thematicDeactivatePieConfig,
} from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";

function ThematicCases({ requestData }) {
  const [chartCounter, setChartCounter] = useState([]);
  const [chartKeys, setChartKeys] = useState([]);

  const [key, setKey] = useState([
    "Resolved",
    "Open",
    "Deactivate",
    "Validated",
    "Unable to resolve",
  ]);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      caseStatusList: [
        "Open",
        "Validated",
        "Resolved",
        "Unable to resolve",
        "Deactivate",
      ],
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getCountiesData(oRequest);
      }
    } else {
      getCountiesData(requestBody);
    }
  }, [requestData]);

  let getCountiesData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getServiceWiseStatusCounter `,
        data
      );
      let formatedData = res.data.data;
      // setChartData(formatedData);
      formatData(formatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const formatData = (data) => {
    let sortOrder = ["Open", "Validated", "Resolved", "Unable to resolve", "Deactivate"];
    
    let sortedArray = Object.entries(data)
    .sort(([keyA], [keyB]) => sortOrder.indexOf(keyA) - sortOrder.indexOf(keyB));
    
    let sortedObject = Object.fromEntries(sortedArray);
    let updatedSorted = Object.keys(sortedObject);
    // Below map loop is used to calculate the percentage
    const transformedArr = updatedSorted.map((item) => {
      let d = item;
      // Find total sum of each object
      const totalSum = Object.keys(data[item]).reduce((prev, key) => {
        return prev + data[item][key];
      }, 0);

      return Object.keys(sortedObject[item]).reduce((prev, key) => {
        if (sortedObject[item][key] == 0 && totalSum == 0) {
          return { ...prev, [key]: 0 };
        } else {
          return {
            ...prev,
            [key]: [
              Math.round((sortedObject[item][key] / totalSum) * 100),
              sortedObject[item][key],
            ],
          };
        }
      }, {});
    });

    let percentObj = {};
    updatedSorted.forEach((item, index) => {
      percentObj[item] = transformedArr[index];
    });

    let allKeysArr = [];
    updatedSorted.forEach((item, index) => {
      allKeysArr = [...allKeysArr, ...Object.keys(percentObj[item])];
    });

    let allUniqueKeyArr = allKeysArr.filter(
      (item, index) => allKeysArr.indexOf(item) === index
    );

    let colourArr = ["#5D8BDD", "#FFD919", "#74B4EE", "#fe6a35", "#89C660"];

    let finalArr = [];

    const randomIntFromInterval = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1) + min);
    };

    const rndInt = randomIntFromInterval(1, 6);
    allUniqueKeyArr.forEach((ele, index) => {
      let mainArr = [];
      let obj = [];
      updatedSorted.forEach((item, ind) => {
        let arr = [];
        let obj = {};
        if (Object.keys(percentObj[item]).includes(ele)) {
          arr = [
            ...arr,
            { percent: percentObj[item][ele][0], y: percentObj[item][ele][1] },
          ];
        } else {
          arr = [...arr, 0];
        }
        mainArr = [...mainArr, ...arr];
      });
      finalArr = [
        ...finalArr,
        {
          name: ele,
          data: mainArr,
          color:
            colourArr[index] !== undefined
              ? colourArr[index]
              : colourArr[randomIntFromInterval(0, colourArr.length)],
        },
      ];
    });
    let showChartkeys = Object.keys(percentObj);
    setChartKeys(showChartkeys);
    setChartCounter(finalArr);
  };

  return (
    <Card>
      <Card.Body className="pb-3">
        <h5>Status of the cases reported by thematic areas</h5>
        {chartCounter && chartCounter.length > 0 ? (
          <ChartComponent
            options={commoditiesBarConfig(chartCounter, chartKeys)}
          />
        ) : (
          <Loader />
        )}
      </Card.Body>
    </Card>
  );
}

export default ThematicCases;
